// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__QHdko","productName":"Table_productName__3NTgF"};